import React from 'react'

const UsecaseMarketeers = ({ style = {}, ...props }) => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={style}
      {...props}>
      <title>usecase-marketeers</title>
      <defs>
        <linearGradient
          x1="50%"
          y1="100%"
          x2="50%"
          y2="3.061617e-15%"
          id="linearGradient-1">
          <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
          <stop stopColor="#FFFFFF" offset="100%" />
        </linearGradient>
        <path
          d="M10.2555408,-4.14336123e-16 L21.7444592,4.14336123e-16 C25.3105342,-2.4074122e-16 26.6036791,0.371302445 27.9073828,1.06853082 C29.2110865,1.76575919 30.2342408,2.78891348 30.9314692,4.09261719 C31.6286976,5.39632089 32,6.68946584 32,10.2555408 L32,21.7444592 C32,25.3105342 31.6286976,26.6036791 30.9314692,27.9073828 C30.2342408,29.2110865 29.2110865,30.2342408 27.9073828,30.9314692 C26.6036791,31.6286976 25.3105342,32 21.7444592,32 L10.2555408,32 C6.68946584,32 5.39632089,31.6286976 4.09261719,30.9314692 C2.78891348,30.2342408 1.76575919,29.2110865 1.06853082,27.9073828 C0.371302445,26.6036791 1.60494146e-16,25.3105342 -2.76224082e-16,21.7444592 L2.76224082e-16,10.2555408 C-1.60494146e-16,6.68946584 0.371302445,5.39632089 1.06853082,4.09261719 C1.76575919,2.78891348 2.78891348,1.76575919 4.09261719,1.06853082 C5.39632089,0.371302445 6.68946584,2.4074122e-16 10.2555408,-4.14336123e-16 Z"
          id="path-2"
        />
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="Group-12" transform="translate(0, -309)">
          <g id="Group-10-Copy-2" transform="translate(0, 308)">
            <g id="usecase-marketeers" transform="translate(0, 1)">
              <g id="Rectangle">
                <use fill="#FD7638" xlinkHref="#path-2" />
                <use
                  fillOpacity="0.15"
                  fill="url(#linearGradient-1)"
                  xlinkHref="#path-2"
                />
              </g>
              <g
                id="profit-up-alt"
                transform="translate(7, 7)"
                fill="#FFFFFF"
                fillRule="nonzero">
                <path
                  d="M3.48387097,10.4516129 L0.580645161,10.4516129 C0.259963694,10.4516129 0,10.7115766 0,11.0322581 L0,16.8387097 C0,17.1593911 0.259963694,17.4193548 0.580645161,17.4193548 L3.48387097,17.4193548 C3.80455244,17.4193548 4.06451613,17.1593911 4.06451613,16.8387097 L4.06451613,11.0322581 C4.06451613,10.7115766 3.80455244,10.4516129 3.48387097,10.4516129 Z M9.29032258,8.12903226 L6.38709677,8.12903226 C6.06641531,8.12903226 5.80645161,8.38899595 5.80645161,8.70967742 L5.80645161,16.8387097 C5.80645161,17.1593911 6.06641531,17.4193548 6.38709677,17.4193548 L9.29032258,17.4193548 C9.61100405,17.4193548 9.87096774,17.1593911 9.87096774,16.8387097 L9.87096774,8.70967742 C9.87096774,8.38899595 9.61100405,8.12903226 9.29032258,8.12903226 Z M17.3090323,4.87741935 L14.1096774,0.580645161 C14.00002,0.434435317 13.8279236,0.348387097 13.6451613,0.348387097 C13.462399,0.348387097 13.2903025,0.434435317 13.1806452,0.580645161 L9.98129032,4.87741935 C9.60387097,5.3883871 9.81290323,5.80645161 10.4458065,5.80645161 L11.6070968,5.80645161 L11.6070968,16.8387097 C11.6070968,17.1593911 11.8670605,17.4193548 12.1877419,17.4193548 L15.0909677,17.4193548 C15.4116492,17.4193548 15.6716129,17.1593911 15.6716129,16.8387097 L15.6716129,5.80645161 L16.8329032,5.80645161 C17.4774194,5.80645161 17.6922581,5.3883871 17.3090323,4.87741935 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default UsecaseMarketeers
